import { Component, OnInit, ViewChild, Inject, Input, EventEmitter, Output } from '@angular/core';
import { LaborService } from '../labor.service';
import { TreeComponent, TreeModel, TREE_ACTIONS, KEYS, IActionMapping, ITreeOptions } from 'angular-tree-component';
@Component({
  selector: 'prodemand',
  templateUrl: './prodemand.component.html',
  styleUrls: ['./prodemand.component.css']
})
export class ProdemandComponent implements OnInit {
  @Input() vinNumber: string;
  @Output() saveProdemand: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild(TreeComponent)
  private tree: TreeComponent;
  options = {};
  nodes = [];
  searchText = '';
  isLoading = false;
  labors = [];
  pathResult = '';
  selectedLaborDetail = '';
  selectedLaborChild = '';
  laborTimes = [];

  constructor(
    private laborService: LaborService,
  ) {

  }

  ngOnInit() {
    console.log('Load Prodemand');
    // this.loadCategories();
    this.searchLabor('');
  }

  loadCategories(): void {
    this.laborService.getCategories()
      .subscribe(data => {
        console.log(data);
        // this.populateNode(data['items']);
      })
  }

  populateNode(categories): void {
    this.nodes = [];
    categories.forEach(c => {
      let node = {};
      let child = [];
      node['name'] = c['name'];
      node['type'] = c['type'];
      c['items'].forEach(ch => {
        let childObj = {};
        childObj['name'] = ch['name'];
        childObj['type'] = ch['type'];
        child.push(childObj);
      });
      node['children'] = child;
      this.nodes.push(node);
    });
    // update the node tree      
    // this.tree.treeModel.update();
  }

  searchLabor(searchInput): void {
    this.isLoading = true;
    this.laborService.searchLaborName(this.vinNumber, searchInput, 'searchText')
      .subscribe(data => {
        if (data['isError'] == false) {
          this.populateNode(data['category']);
        } else {
          alert('API is error. Please inform to Bao');
        }
        this.isLoading = false;
      })
  }

  save(): void {
    this.saveProdemand.emit(this.pathResult);
    // this.dialogRef.close({
    //   pathResult: this.pathResult,
    // });
  }

  checkIfExist(labors): boolean {
    if (this.pathResult.includes(labors.name) && this.pathResult.includes(labors.operation)) {
      return true;
    }
    return false;
  }

  setParthResult(laborDetail): void {
    if (this.pathResult.indexOf('|') > -1) {
      let laborIndex = this.pathResult.indexOf('|');
      this.pathResult = this.pathResult.substring(laborIndex, -1);
    }
    this.pathResult = this.pathResult + '|' + laborDetail.application;
    this.selectedLaborChild = laborDetail.application;
  }

  selectLaborDetail(laborDetail): void {
    if (this.checkIfExist(laborDetail)) {
      return;
    }

    this.isLoading = true;
    console.log(this.selectedLaborDetail);
    if (this.selectedLaborDetail != '') {
      let laborIndex = this.pathResult.indexOf('/' + this.selectedLaborDetail);
      if (laborIndex > -1) {
        this.pathResult = this.pathResult.substring(laborIndex, -1);
      }
    }
    console.log(this.pathResult);
    // let urlForLaborTime = this.pathResult.replace('>', '/');
    let urlForLaborTime = this.pathResult;
    this.selectedLaborDetail = this.formatUrl(laborDetail.name) + '/' + this.formatUrl(laborDetail.operation);

    // this.pathResult = this.pathResult + '/' + laborDetail.name + '/' + laborDetail.operation;
    urlForLaborTime = urlForLaborTime + '/' + this.selectedLaborDetail;
    this.pathResult = urlForLaborTime;
    this.laborService.getLaborDetails(this.vinNumber, urlForLaborTime, 'laborTimes')
      .subscribe(data => {
        this.laborTimes = data['labors'];
        this.isLoading = false;
      })
  }

  selectLabor(event): void {
    let type = event.node.data.type;
    this.laborTimes = [];

    if (type == 'terminal') {
      this.isLoading = true;
      this.labors = [];
      let laborName = event.node.data.name;
      let parentName = event.node.parent.data.name;

      let path = this.formatUrl(parentName) + '/' + this.formatUrl(laborName);
      this.pathResult = path;

      if (type == 'terminal') {
        this.laborService.getLaborDetails(this.vinNumber, path, 'laborDetail')
          .subscribe(data => {
            this.labors = data['labors'];
            this.isLoading = false;
          })
      }
    }
  }

  formatUrl(urlStr): string {
    urlStr = urlStr.replace(' ', '%20');
    urlStr = urlStr.replace('&', '!26!');
    urlStr = urlStr.replace('A/C', 'A!2F!C');
    urlStr = urlStr.replace('/', '!2F!');
    urlStr = urlStr.replace('>', '/');
    urlStr = urlStr.replace('slash', '/');
    return urlStr;
  }

}
